import fetch from './fetch'

export default {
  addViewPersonLog (payload) {
    let request = fetch({
      url: `/view/person`,
      method: 'post',
      data: payload,
      payload: {}
    })
    return request.call()
  },
  addViewNoteLog (payload) {
    let request = fetch({
      url: `/view/note`,
      method: 'post',
      data: payload,
      payload: {}
    })
    return request.call()
  },
  addViewAssessmentLog (payload) {
    let request = fetch({
      url: `/view/assessment`,
      method: 'post',
      data: payload,
      payload: {}
    })
    return request.call()
  },
  getLogs (payload) {
    let request = fetch({
      url: `/log`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  clearTestData (payload) {
    let request = fetch({
      url: `/view/clear-test-data`,
      method: 'post',
      data: payload,
      payload: {}
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/log.js